import { render } from "./langganan-banner.vue?vue&type=template&id=8b49373e&scoped=true"
import script from "./langganan-banner.vue?vue&type=script&lang=js"
export * from "./langganan-banner.vue?vue&type=script&lang=js"

import "./langganan-banner.vue?vue&type=style&index=0&id=8b49373e&scoped=true&lang=css"

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b49373e"]])

export default __exports__